import 'default-passive-events';
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app';
import mitt from 'mitt';
import { startNprogress, closeNprogress } from '@/nprogress/nprogress';
import { setChannelCid, getChannelCid, setSelectCurrency, setCarrierList, setCountryListFun, setBelongAreaFun, setDeviceTypeFun, setCountryObjFun, setSelectLanguage } from '@/store/locale';
import type { CountryObj, CountryItem } from '#/locale';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { convertChangeDataTurn } from '@/utils/convartChangeDataTurn';
import { setupGlobalMethods } from '@/pluginFun';
import { ApiGetAirlineList } from '@/apis/home';
import { getCountryListApi } from '@/apis/common';
import { getPatLocalApi } from '@/apis/order';
import { getFlightPriceVerify } from '@/logic/flights';
import { setAesCryptoStrFun, setSessionIdFun } from '@/store/order';
import { setCurFlightFun } from '@/store/flight';
import { routeGo } from '@/hooks/web/jumpGo';
import { formatFlight } from '@/logic/flights/formatFlight';
import { setPriceInfoFun } from '@/utils/convertPriceInfo';
import { goJumpSearchResult } from '@/utils/jumpSearchResult';
import type { Airports } from '@/apis/order/model';
import { ElMessage } from 'element-plus';
import Cookies from 'js-cookie';
import { memberGuestLoginFun } from '@/logic/header';

function setupPlugins(app: any) {
	// 注册全局常用方法
	setupGlobalMethods(app);
}
async function getCarrierFun() {
	const airlineList = await ApiGetAirlineList();
	setCarrierList(airlineList);
	convertChangeDataTurn(airlineList);
}
function getCountryFun() {
	getCountryListApi().then((countryList: any[]) => {
		const countryObj: CountryObj = {};
		countryList.forEach((item: CountryItem) => {
			if (item.countryCode) {
				countryObj[item.countryCode] = item;
			}
		});
		setCountryObjFun(countryObj);
		setCountryListFun(countryList);
	});
}
function getLocationFun() {
	getPatLocalApi().then(res => {
		if (res) {
			const { code, data } = res;
			if (code === 0) {
				const { belongArea, deviceType } = data;
				setBelongAreaFun(belongArea);
				setDeviceTypeFun(deviceType);
			}
		}
	});
}
async function getWegoOrderPriceVerifyFun(route: any, $i18n: any) {
	const cid = route.query.cid as string;
	const data = route.query.data as string;
	let otaReferenceId = '';
	if (route.query.skyscanner_redirectid) {
		otaReferenceId = route.query.skyscanner_redirectid as string;
		Cookies.set('currentSourceName', 'skyscanner_redirectid', { expires: 30 });
	}
	if (route.query.wego_click_id) {
		otaReferenceId = route.query.wego_click_id as string;
		Cookies.set('currentSourceName', 'wego_click_id', { expires: 30 });
	}
	if (route.query.skyscanner_redirectid || route.query.wego_click_id) {
		memberGuestLoginFun();
	}
	Cookies.set('otaReferenceId', otaReferenceId, { expires: 30 });
	const res = await getFlightPriceVerify(cid, data, true, otaReferenceId);
	const { searchCondition, searchRoutings, sessionId, ok, airports, status } = res;
	if (status === 0) {
		const storeFlight: any = formatFlight([searchRoutings], searchCondition, airports);
		// @ts-ignore
		storeFlight.flightList[0].sessionId = sessionId;
		//@ts-ignore
		storeFlight.flightList[0].commission = res.commission;
		//@ts-ignore
		storeFlight.flightList[0].sellLuggage = res.sellLuggage;
		setPriceInfoFun(res, searchCondition);
		setSessionIdFun(sessionId);
		setAesCryptoStrFun(ok);
		setCurFlightFun(storeFlight?.flightList[0]);
		routeGo('addPassenger');
	} else {
		ElMessage.warning($i18n.t('tipMsg.hangbanyishouqing'));
		handlePriceCheckFalse(route, airports, $i18n.locale);
	}

}
// 验价失败
async function handlePriceCheckFalse(route: any, airports: Airports[], locale: any) {
	// 验价失败跳转查询页面
	const dataStr = route.query.data as string;
	const currentCurrency = route.query.currency as string;
	const tempData = dataStr.split('_');
	const count: number = Number(tempData[8]) + Number(tempData[9]) + Number(tempData[10]);
	let fromCityName = '';
	let fromCityCode = tempData[3];
	let toCityCode = tempData[4];
	let toCityName = '';
	const tripType = tempData[7];
	const adults = Number(tempData[8]);
	const children = Number(tempData[9]);
	const infant = Number(tempData[10]);
	if (airports && airports.length > 0) {
		airports.forEach((item: Airports) => {
			if (tempData[3]) {
				if (tempData[3] === item.airportCode) {
					// @ts-ignore
					fromCityName = item['cityName' + locale.value];
					fromCityCode = item.cityCode;
				}
				if (tempData[4]) {
					if (tempData[4] === item.airportCode) {
						// @ts-ignore
						toCityName = item['cityName' + locale.value];
						toCityCode = item.cityCode;
					}
				}
			}

		});
		const requestData = {
			adults,
			children,
			infant,
			cabinGrade: tempData[11],
			count,
			fromCityName,
			fromCityCode,
			toCityCode,
			toCityName,
			retDate: tempData[6],
			fromDate: tempData[5],
			tripType: Number(tripType)
		};
		goJumpSearchResult(requestData);
	} else {
		window.location.href = window.location.origin + '/' + locale.value + '/flights/search/' + fromCityCode + '/' + toCityCode + '?' + 'adults=' + adults + '&children=' + children + '&infant=' + infant + '&startDate=' + tempData[5] + '&endDate=' + tempData[6] + '&tripType=' + tripType + '&seatClass=' + tempData[11] + '&currency=' + currentCurrency;
	}
}

export default defineNuxtPlugin((nuxtApp: any) => {
	const { nuxtChannelId } = useRuntimeConfig().public;
	// 记住以后有接口需要cid就使用getChannelCid()这个store导入不要用$nuxtChannelId
	if (nuxtApp._route.query.cid) {
		setChannelCid(nuxtApp._route.query.cid as string);
	} else {
		if (!getChannelCid()) {
			setChannelCid(nuxtChannelId as string);
		}
	}
	if (process.client) {
		nuxtApp.$pinia.use(piniaPluginPersistedstate);
		getLocationFun();
		getCarrierFun();
		getCountryFun();
		nuxtApp.$router.beforeEach(() => {
			startNprogress();
		});
		nuxtApp.$router.afterEach(() => {
			closeNprogress();
		});
		const app = nuxtApp.vueApp;
		const routePathStr = nuxtApp._route.path;
		if (routePathStr) {
			const routePathArr = routePathStr.split('/');
			if (routePathArr.length > 0) {
				const routePathName = routePathArr[2];
				if (routePathName === 'flightLoading') {
					getWegoOrderPriceVerifyFun(nuxtApp._route, nuxtApp.$i18n);
				}
			}
		}
		setupPlugins(app);
		// 为了后面的flightLoading做的逻辑处理
		// 以后所有用这个币种的就用getSelectCurrency()方法获取
		if (nuxtApp._route.query.currency) {
			setSelectCurrency(nuxtApp._route.query.currency);
		}
		const locale = nuxtApp.$i18n.locale;
		if (locale) {
			if (locale.value) {
				setSelectLanguage(locale.value);
			}
		}
	}

	return {
		provide: {
			eventBus: mitt(),
			webTitle: useRuntimeConfig().public.nuxtTitleEnv
		}
	};
});


